<template>
	<div style="height:100%;width: 100%;background: #fff;" class="eqdetails">
		<!-- <span style="font-size: 24px;font-weight: 800;margin-left: 10px;color:#3fb393 ;">{{eqDetailInfo.name}}</span>
		<span style="font-size: 24px;font-weight: 800;">设备详细数据</span> -->
		<span style="float: right;cursor: pointer; font-size: 24px;font-weight: 800;" class="el-icon-close" @click="detailClose"></span>
		<div style="display: flex;margin-top: 8px;" >
			<img style="width: 70px;height: 70px; margin: 0 20px;"
			:src="$store.getters.getPostUrl+'mes/sysFile/download/'+eqDetailInfo.img" :onerror="defaultImg">
			<div>
				<span style="font-size: 18px;font-weight: 600;">
					{{(eqDetailInfo.code==null?'':eqDetailInfo.code)}}&nbsp;{{eqDetailInfo.companyNumber==null?'':'<'+eqDetailInfo.companyNumber+'>'}}<br />
				</span>
				<span style="font-size: 18px;font-weight: 600;">
					{{(eqDetailInfo.code==null?'':eqDetailInfo.code)}}&nbsp;{{eqDetailInfo.name}}
				</span><br />
				<span style="font-size: 14px;font-weight: 600;">
					{{eqDetailInfo.superior}}
				</span>
			</div>
			<!-- <div>
				<span style="font-size: 20px;font-weight: 800;margin-left: 10px;color:#3fb393 ;">使用寿命：</span>
				<span style="font-size: 20px;font-weight: 800;">{{eqDetailInfo.useTime}}</span>
			</div> -->
		</div>
		<el-tabs v-model="eqTabs" style="height: calc(100% - 75px);">
			<el-tab-pane :label="$t('label_651')" name="eqDay" v-if="MenuRoleList.indexOf('412')>=0">
				<daily v-if="eqTabs=='eqDay'" ref="daily" :eqDetailInfo="eqDetailInfo" :workTime="workTime"></daily>
			</el-tab-pane>
			<el-tab-pane :label="$t('label_653')" name="eqWeek" v-if="MenuRoleList.indexOf('413')>=0">
				<weekly v-if="eqTabs=='eqWeek'" ref="weekly" :eqDetailInfo="eqDetailInfo" :workTime="workTime" ></weekly>
			</el-tab-pane>
			<el-tab-pane :label="$t('label_656')" name="eqMonth" v-if="MenuRoleList.indexOf('414')>=0">
				<monthlyReport v-if="eqTabs=='eqMonth'" ref="eqMonth" :eqDetailInfo="eqDetailInfo" :workTime="workTime"></monthlyReport>
			</el-tab-pane>
			<el-tab-pane :label="$t('label_658')" name="eqYear" v-if="MenuRoleList.indexOf('415')>=0">
				<annualReport v-if="eqTabs=='eqYear'" ref="eqYear" :eqDetailInfo="eqDetailInfo" :workTime="workTime"></annualReport>
			</el-tab-pane>
		</el-tabs>
	</div>
</template>

<script>
	import utils from '@/utils/utils'
	import equipmentMonitoringService from "@/assets/js/signal/equipmentMonitoringService.js"
	import daily from "@/components/list/equipmentDetails/daily";
	import weekly from "@/components/list/equipmentDetails/weekly";
	import monthlyReport from "@/components/list/equipmentDetails/monthlyReport";
	import annualReport from "@/components/list/equipmentDetails/annualReport";

	export default {
		name: "eqDetail",
		components: {
			daily,
			weekly,
			monthlyReport,
			annualReport,
		},
		props: ['eqId'],
		data() {
			return {
				eqTabs: '',
				workTime: {},
				eqDetailInfo: {},
				MenuRoleList: [],
				defaultImg: 'this.src="'+require('@/assets/img/deviceDefaultImg.png')+'"',
			}
		},
		methods: {
			//查询上下班时间
			getWorkTime: function() {
				equipmentMonitoringService.getWorkTime().then((response) => {
					const data = response.data;
					if (data.code == "1") {
						this.workTime = data.data;
						this.getEqDetailInfo();
					};
				}).catch((response) => {
					console.log(response)
				})
			},
			//查询设备信息
			getEqDetailInfo: function() {
				equipmentMonitoringService.selectEquipmentAll({id: this.eqId,type: 1}).then((response) => {
				  const data = response.data;
				  if (data.code == "1") {
					  this.eqDetailInfo = data.data[0];
					  this.eqTabs ='eqDay';
				  }
				}).catch((response) => {
				  console.log(response)
				})
			},
			//关闭设备详细信息
			detailClose:function(){
				this.$emit('detailClose');
			},
		},
		created() {
			this.getWorkTime();
			this.MenuRoleList = this.$store.getters.getMenu;
		},
    // watch: {
    //   eqId(val) {
    //     console.log(this.eqId)
    //     if (val != undefined && val != '') {
    //       this.getWorkTime();
    //     }
    //   }
    // }
	}
</script>
<style>
  .background1 .treeMes .eqdetails .el-tabs__content{
    height: 90%;
  }
</style>



// WEBPACK FOOTER //
// src/components/list/equipmentDetails/eqDetail.vue